var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUndo32 = function SvgIconUndo32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.389 13.666h-9.56V11.4h9.56a5.572 5.572 0 0 1 5.573 5.573 5.572 5.572 0 0 1-5.573 5.574h-2.734V20.28h2.734a3.305 3.305 0 0 0 3.306-3.307 3.305 3.305 0 0 0-3.306-3.306Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.103 12.53 4.058-3.907-1.573-1.633-4.305 4.145v.001c-.791.76-.791 2.028 0 2.788l4.305 4.146 1.573-1.633-4.058-3.907Zm-1.035-.577.785.817-.785-.817Z",
    fill: "current"
  })));
};
export default SvgIconUndo32;